module.exports = __webpack_public_path__ + "static/media/suzie-medium-shot.9fa02830.png";